import $ from "cash-dom";
import { fetchHTML } from "Utilities";

const component = (function () {
    $(window).on("load", function () {
        if ($("body").hasClass("logged-in")) {
            console.log("component-l10n initialized");

            var languages = {};

            $(".jdmn-lang-toggle").each(function () {
                var languageSlug = $(this).attr("id").replace("wp-admin-bar-jdmn-lang-", "");
                var languageHref = $(this).find("a").attr("href");

                fetchHTML({
                    url: languageHref,
                    beforeSend: function () {},
                    complete: function (_html) {
                        if (_html) {
                            var parser = new DOMParser();
                            var html = $(parser.parseFromString(_html, "text/html"));
                            var main = $(html).find("main");

                            languages[languageSlug] = main;
                        }
                    },
                    error: function (_error) {
                        console.log(_error);
                    },
                });
            });

            $(".jdmn-lang-toggle a").on("click", function (e) {
                var selectedLanguageName = $(e.target).text();
                var selectedLanguageSlug = $(e.target).parent().attr("id").replace("wp-admin-bar-jdmn-lang-", "");
                var selectedLanguageIndicator = $("#wp-admin-bar-jdmn-lang > .ab-item");
                var selectedLanguageMain = languages[selectedLanguageSlug];

                e.preventDefault();

                selectedLanguageIndicator.text(selectedLanguageName);
                $("main").replaceWith(selectedLanguageMain);
            });
        }
    });
})();

export default component;
